"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservationAddToDatasetConfigSchema = exports.AddToDatasetMappingSchema = exports.FieldMappingConfigSchema = exports.CustomMappingConfigSchema = exports.KeyValueMappingEntrySchema = exports.RootMappingConfigSchema = exports.MappingTargetSchema = exports.MappingModeSchema = exports.SourceFieldSchema = void 0;
const zod_1 = __importDefault(require("zod"));
// Source field type
exports.SourceFieldSchema = zod_1.default.enum(["input", "output", "metadata"]);
// Mapping mode for each field
exports.MappingModeSchema = zod_1.default.enum(["full", "custom", "none"]);
// Mapping target type: "root" extracts single value, "keyValueMap" builds an object
exports.MappingTargetSchema = zod_1.default.enum(["root", "keyValueMap"]);
// Root mapping config - single JSON path extraction
exports.RootMappingConfigSchema = zod_1.default.object({
    sourceField: exports.SourceFieldSchema,
    jsonPath: zod_1.default.string(),
});
// Key-value mapping entry - key-value pair for building objects
exports.KeyValueMappingEntrySchema = zod_1.default.object({
    id: zod_1.default.string(),
    key: zod_1.default.string().min(1, "Key is required"),
    sourceField: exports.SourceFieldSchema,
    value: zod_1.default.string(), // JSON path if starts with $, else literal string
});
// Custom mapping config - either root or key-value map type
exports.CustomMappingConfigSchema = zod_1.default.object({
    type: exports.MappingTargetSchema,
    rootConfig: exports.RootMappingConfigSchema.optional(),
    keyValueMapConfig: zod_1.default
        .object({
        entries: zod_1.default
            .array(exports.KeyValueMappingEntrySchema)
            .min(1, "At least one entry is required"),
    })
        .optional(),
});
// Per-field mapping config
exports.FieldMappingConfigSchema = zod_1.default.object({
    mode: exports.MappingModeSchema,
    custom: exports.CustomMappingConfigSchema.optional(),
});
// Complete mapping config for all three fields
exports.AddToDatasetMappingSchema = zod_1.default.object({
    input: exports.FieldMappingConfigSchema,
    expectedOutput: exports.FieldMappingConfigSchema,
    metadata: exports.FieldMappingConfigSchema,
});
// Config for the batch action
exports.ObservationAddToDatasetConfigSchema = zod_1.default.object({
    datasetId: zod_1.default.string(),
    datasetName: zod_1.default.string(),
    mapping: exports.AddToDatasetMappingSchema,
});
